import {
  getClickFeature,
  getFeature,
} from '@micro-frontend-react/employee-experience/lib/UsageTelemetryHelper';
import { TextField } from '@micro-frontend-react/employee-experience/lib/TextField';
import { PrimaryButton } from 'office-ui-fabric-react/lib/components/Button';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IUserProfile } from '../../../models/IUserProfile';
import { requesteTemplates } from '../../../redux/actions/templateActions';
import { setUserImpersonation } from '../../../redux/actions/userImpersonationActions';
import * as styled from './Impersonation.styled';
import { ImpersonationLabel } from './Impersonation.styled';

export interface IImpersonationProps {
  userProfile: IUserProfile | null;
}

export function Impersonation(props: IImpersonationProps): React.ReactElement {
  const [companyCode, setCompanyCode] = React.useState<string>();
  const [costCenter, setCostCenter] = React.useState<string>();
  const feature = getFeature('EVL', 'Impersonation');
  const dispatch = useDispatch();
  const currentImpersonation = useSelector((state: any): IUserProfile => {
    return state === null || state === undefined
      ? null
      : {
          alias: state.userImpersonation.alias,
          allowedAva: state.userImpersonation.allowedAva,
          allowedImpersonation: state.userImpersonation.allowedImpersonation,
          companyCode: state.userImpersonation.companyCode,
          costCenter: state.userImpersonation.costCenter,
        };
  });

  return (
    <>
      <styled.ImpersonationContainer>
        <p>
          Original: <b>Company Code</b> {props?.userProfile?.companyCode} <b>Cost Center</b>{' '}
          {props?.userProfile?.costCenter}
        </p>
      </styled.ImpersonationContainer>
      <styled.ImpersonationPageContainer>
        <styled.ControlContainer>
          <ImpersonationLabel aria-hidden={true}>Company Code</ImpersonationLabel>
          <TextField
            aria-roledescription={'Company Code Textbox'}
            name={'companyCode'}
            label=""
            role={'textbox'}
            ariaLabel={'Company Code'}
            aria-placeholder={currentImpersonation?.companyCode}
            aria-label={'Company Code'}
            onChange={(id, value) => {
              setCompanyCode(value);
            }}
            placeholder={currentImpersonation?.companyCode}
            value={companyCode}
            {...getClickFeature(feature, 'CompanyCode')}
          ></TextField>
        </styled.ControlContainer>
        <styled.ControlContainer>
          <ImpersonationLabel aria-hidden={true}>Cost Center</ImpersonationLabel>
          <TextField
            aria-roledescription={'Cost Center Textbox'}
            name={'costCenter'}
            label=""
            ariaLabel={'Cost Center'}
            aria-placeholder={currentImpersonation?.costCenter}
            aria-label={'Cost Center'}
            role={'textbox'}
            onChange={(id, value) => {
              setCostCenter(value);
            }}
            placeholder={currentImpersonation?.costCenter}
            value={costCenter}
            {...getClickFeature(feature, 'CostCenter')}
          ></TextField>
        </styled.ControlContainer>
        <styled.ControlContainer>
          <PrimaryButton
            title={`Update Impersonation`}
            text={'Update Impersonation'}
            style={{ marginRight: 10 }}
            disabled={false}
            onClick={() => {
              dispatch(
                setUserImpersonation({
                  ...props.userProfile,
                  companyCode: companyCode,
                  costCenter: costCenter,
                })
              );
            }}
          />
        </styled.ControlContainer>
        <styled.ControlContainer>
          <PrimaryButton
            title={`Clear Impersonation`}
            text={'Clear Impersonation'}
            style={{ marginRight: 10 }}
            disabled={false}
            onClick={() => {
              setCompanyCode('');
              setCostCenter('');
              dispatch(setUserImpersonation({}));
              dispatch(requesteTemplates(feature, null, null));
            }}
          />
        </styled.ControlContainer>
      </styled.ImpersonationPageContainer>
    </>
  );
}
